var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"empty-new",style:(_vm.wrapStyle)},[_c('div',{staticClass:"empty-news-title"},[_vm._t("title",[_vm._v(_vm._s(_vm.title))])],2)])}
var staticRenderFns = []

export { render, staticRenderFns }